import { FC, SyntheticEvent, useState } from 'react';
import { useMutation } from '@apollo/client';
import Dialog from 'components/common/Dialog/Dialog';
import Input from 'components/common/Input/Input';
import ELEMENT from 'common/element';
import { CREATE_SECRET, SECRETS_DATA } from '../queries';
import { isDescriptionValidRegex, isNameValidRegex, isSecretValidRegex } from '../consts';

import '../styles.scss';

type AddSecretDialogProps = {
  addSecretDialogIsOpen: boolean;
  setAddSecretDialogIsOpen: (open: boolean) => void;
  handleChange: () => void;
};

/**
 *
 * A dialog that add Secrets
 *
 */
const AddSecretDialog: FC<AddSecretDialogProps> = ({
  handleChange,
  addSecretDialogIsOpen,
  setAddSecretDialogIsOpen,
}) => {
  const [createSecret] = useMutation(CREATE_SECRET, { refetchQueries: [SECRETS_DATA] });

  const [name, setName] = useState<string>('');
  const isNameValid = isNameValidRegex.test(name);
  const onNameChange = (e: SyntheticEvent): void => {
    setName((e?.target as HTMLTextAreaElement)?.value);
  };

  const [description, setDescription] = useState<string>('');
  const isDescriptionValid = isDescriptionValidRegex.test(description);
  const onDescriptionChange = (e: SyntheticEvent): void => {
    setDescription((e?.target as HTMLTextAreaElement)?.value);
  };

  const [secretValue, setSecretValue] = useState<string>('');
  const isSecretValueValid = isSecretValidRegex.test(secretValue);
  const onSecretValueChange = (e: SyntheticEvent): void => {
    setSecretValue((e?.target as HTMLTextAreaElement)?.value);
  };

  const reset = (): void => {
    setName('');
    setDescription('');
    setSecretValue('');
  };

  const onDialogSubmit = (): void => {
    createSecret({ variables: { name: name, description: description, secretValue: secretValue } });
    handleChange();
    reset();
  };

  const onClose = (): void => {
    reset();
    setAddSecretDialogIsOpen(false);
  };

  return (
    <Dialog
      title="Add Secret"
      className="SecretsPage__Modal"
      show={addSecretDialogIsOpen}
      close={onClose}
      okCallback={onDialogSubmit}
      okButtonDisabled={!(isNameValid && isSecretValueValid && isDescriptionValid)}
      okButtonText="Submit"
      testId={ELEMENT.addSecretDialog}
      size="lg"
    >
      <div>
        <Input
          label="Name"
          onChange={onNameChange}
          isInvalid={!isNameValid}
          value={name}
          placeholder="Name of your secret"
          testId={ELEMENT.newSecretInput}
          size="lg"
        />
        <Input
          label="Description"
          onChange={onDescriptionChange}
          isInvalid={!isDescriptionValid}
          value={description}
          placeholder="Describe of your secret"
          testId={ELEMENT.newSecretInput}
          size="lg"
        />
        <Input
          label="Secret Value"
          onChange={onSecretValueChange}
          isInvalid={!isSecretValueValid}
          value={secretValue}
          placeholder="Your secret value"
          testId={ELEMENT.newSecretInput}
          size="lg"
        />
      </div>
    </Dialog>
  );
};

export default AddSecretDialog;
